import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { PortalContextService, PortalType } from '../auth/portal-context.service';

export const portalEntryGuard: CanMatchFn = () => {
  const portal = inject(PortalContextService);
  return inject(Router).createUrlTree([portal.loginRoute]);
};

function portalGuard(expected: PortalType): CanActivateFn {
  return () => {
    const portal = inject(PortalContextService);
    if (!portal.isDedicatedHost || portal.portal === expected) return true;
    return inject(Router).createUrlTree([portal.loginRoute]);
  };
}

export const adminPortalGuard = portalGuard('admin');
export const businessPortalGuard = portalGuard('business');
export const franchisePortalGuard = portalGuard('franchise');
